import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MembershipPaymentComponent } from './membership-payment/membership-payment.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { InsurnceComponent } from './insurnce/insurnce.component';

const routes: Routes = [
  { path: 'callADoc', component: LoginComponent },
  { path: 'membershipPayment', component: MembershipPaymentComponent },
  { path: 'subscriptions', component: SubscriptionsComponent },
  { path: 'insurance', component: InsurnceComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
